import linkifyElement from 'linkify/element'

window.linkifyElement = linkifyElement
